import GenericRequest, { METHOD_PUT } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export default class AddTypeDocumentRequest extends GenericRequest {

    typedocument;

    constructor(typedocument) {
        super(METHOD_PUT, ApiEndpoints.DOCUMENTS_TYPE);

        this.typedocument = typedocument;
    }

    overrideRequest() {
        let request = {};
        if ( this.typedocument ) request = { ...request, ...this.typedocument };
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/documents/ws/AddTypeDocumentRequest.js